/** Angular core dependencies */
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

/** Third party modules */
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";

/** Custom Components */
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from "./header/header.component";
import { LoadingPlaceholderComponent } from "./loading-placeholder/loading-placeholder.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { SpinnerComponent } from "./spinner/spinner.component";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { AddiconComponent } from "./addicon/addicon.component";
import { ViewiconComponent } from "./viewicon/viewicon.component";
import { EditiconComponent } from "./editicon/editicon.component";
import { DeleteiconComponent } from "./deleteicon/deleteicon.component";
import { PrevnexticonComponent } from "./prevnexticon/prevnexticon.component";
import { TogglebuttonComponent } from "./togglebutton/togglebutton.component";
import { CanceliconComponent } from "./cancelicon/cancelicon.component";
import { PaginationbarComponent } from "./paginationbar/paginationbar.component";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatCardModule } from "@angular/material/card";
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { LoaderService } from "@shared/async-services/loader/loader.service";
import { LoaderComponent } from './loader/loader.component';
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatListModule } from "@angular/material/list";
import { TableComponent } from "./table/table.component";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { TooltipModule } from "primeng/tooltip";
import { RatingModule } from "primeng/rating";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TagModule } from "primeng/tag";
import { DownloadDialogComponent } from "./download-dialog/download-dialog.component";
import { TableTextConcat } from "./pipes/concat.pipe";
import { ExchangeLoginComponent } from "./exchange-login/exchange-login.component";
/** Custom Components Registration*/
export const COMPONENTS = [
  FooterComponent,
  HeaderComponent,
  LoadingPlaceholderComponent,
  PageNotFoundComponent,
  SpinnerComponent,
  AddiconComponent,
  ViewiconComponent,
  EditiconComponent,
  DeleteiconComponent,
  CanceliconComponent,
  PrevnexticonComponent,
  TogglebuttonComponent,
  PaginationbarComponent,
  BreadcrumbComponent,
  LoaderComponent,
  TableComponent,
  DownloadDialogComponent,
  TableTextConcat,
  ExchangeLoginComponent
];

@NgModule({
  imports: [
    /** Angular core dependencies */
    CommonModule,
    RouterModule,
    /** Third party modules */
    TableModule,
    NgbModule,
    MatCardModule,
    TranslateModule,
    MatTableModule,
    MatTabsModule,
    MatBadgeModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    NgxUiLoaderModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    ButtonModule,
    MatSlideToggleModule,
    TooltipModule,
    RatingModule,
    FormsModule,
    MatProgressSpinnerModule,
    TagModule,
    ReactiveFormsModule
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [LoaderService]
})
export class ComponentsModule {}
